import { Experience } from '../../types';
import { ui } from '../../data/ui';
import { ScrollReveal } from './ScrollReveal';
import './TimelineItem.css';

interface TimelineItemProps {
  experience: Experience;
  index: number;
  isLast: boolean;
}

export function TimelineItem({ experience, index, isLast }: TimelineItemProps) {
  return (
    <ScrollReveal delay={index * 0.1} className="timeline-item-wrapper">
      <div className={`timeline-item ${experience.isCurrent ? 'timeline-item-current' : ''}`}>
        <div className="timeline-marker">
          <div className="timeline-dot" />
          {!isLast && <div className="timeline-line" />}
        </div>
        <div className="timeline-content glass-card">
          <div className="timeline-header">
            <div>
              <span className="timeline-date">
                {experience.startDate} — {experience.endDate}
              </span>
              <h3 className="timeline-company">{experience.company}</h3>
              <span className="timeline-location">{experience.location}</span>
            </div>
            {experience.isCurrent && <span className="tag">{ui.experience.current}</span>}
          </div>

          {experience.roleTransition && (
            <div className="role-transition">
              <span className="role-from">{experience.roleTransition.from}</span>
              <span className="role-arrow">↓</span>
              <span className="role-to">{experience.roleTransition.to}</span>
            </div>
          )}

          <h4 className="timeline-role">{experience.role}</h4>
          {experience.previousRole && (
            <span className="timeline-previous-role">{ui.experience.previously} {experience.previousRole}</span>
          )}
          {experience.project && (
            <span className="timeline-project">{ui.experience.project} {experience.project}</span>
          )}

          {experience.companyUrl && (
            <a
              href={experience.companyUrl}
              className="timeline-company-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {ui.experience.visitCompany} ↗
            </a>
          )}

          <div className="timeline-descriptions">
            {experience.description.map((desc, i) => (
              <p key={i}>{desc}</p>
            ))}
          </div>

          <ul className="timeline-highlights">
            {experience.highlights.map((highlight, i) => (
              <li key={i}>{highlight}</li>
            ))}
          </ul>

          <div className="timeline-tech">
            {experience.technologies.map((tech) => (
              <span key={tech} className="tag tag-secondary">{tech}</span>
            ))}
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
